"use client";

import type { CSSProperties } from "react";
import InlineReadMoreText from "@components/atoms/InlineReadMoreText/InlineReadMoreText";
import { SEO_MM_PAGE_CONTENT } from "@constants/seo-mm-page-content";
import styles from "./MMSeoContentBlock.module.scss";

interface MMSeoContentBlockProps {
  slug?: string;
  className?: string;
  mobileCentered?: boolean;
  isInApp?: boolean;
}

export default function MMSeoContentBlock({
  slug,
  className = "",
  mobileCentered = false,
  isInApp = false
}: MMSeoContentBlockProps) {
  const content = slug ? SEO_MM_PAGE_CONTENT[slug] : undefined;

  if (!content || isInApp) {
    return null;
  }

  return (
    <div
      className={`${styles.wrapper} ${mobileCentered ? styles.mobileCentered : ""} ${className}`}
    >
      <InlineReadMoreText
        text={content}
        maxLines={2}
        readMoreText="Read more"
        readLessText="see less"
        truncateOnDesktop={true}
        className={styles.description}
        textClassName={styles.content}
        ellipsisClassName={styles.ellipsis}
        readMoreClassName={styles.readMore}
        readLessClassName={styles.readLess}
        style={
          {
            "--tail-background": "#171717",
            "--ellipsis-right-desktop": "80px",
            "--ellipsis-right-mobile": "62px",
          } as CSSProperties
        }
      />
    </div>
  );
}
